<script>
import store from '@/modules/store'
import restaurantList from '@/modules/mixins/restaurantList'
import BannerLanding from '@/components/organism/restaurants/BannerLanding.vue'
import Banners from '@/components/organism/restaurants/Banners.vue'
export default {
    name: 'Restaurants',
    components: { Banners, BannerLanding },

    mixins: [restaurantList],

    computed: {
        restaurants() {
            return this.$restaurants
        },
        hasBanner() {
            return !!this.$route.query.bannerId
        },
    },

    async beforeRouteEnter(to, from, next) {
        store.dispatch('canteen/initBanner')
        store.dispatch('canteen/getResidentialList')
        next(async (vm) => {
            try {
                await vm.$location?.check(to)
                await restaurantList.methods.setList(vm.restaurants, to)
            } finally {
                vm.$cart.calculate()
                vm.pageLoading = false
            }
        })
    },
}
</script>

<template lang="pug">
transition(name="fade" mode="out-in")
    spinner.full-center.position-sticky(v-if="pageLoading")
    .restaurants-page.pt-page.pb-page(v-else)
        .row
            .col-md-auto.pl-md-0(v-if="!smDevice")
                tags-select.mb-md-5
            .col
                canteen-banner.mb-5(v-if="showCanteenBanner")
                tag-select.mb-5(v-if="!hasBanner && showTagSelect")
                banner-landing
                banners.mb-5
                popular-restaurants.mb-5(v-if="!hasBanner && showPopularRestaurants" :restaurants="restaurants")
                featured-restaurants.mb-5(v-if="!hasBanner && showPopularRestaurants" :restaurants="restaurants")
                list(:restaurants="restaurants" :set-list="setList")
                restaurants-loader(:restaurants="restaurants")
        tracking-alert

</template>
